import { mapState } from "vuex";

export default {
  computed: {
    userHasAdminRights() {
      return [2, 4, 6, 10, 12].includes(this.user.accessType);
    },
    ...mapState(["user"]),
  },
};
